
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  MissingCompanyDetailsRequest,
  ValidationError,
} from '../models';
import {
    MissingCompanyDetailsRequestFromJSON,
    MissingCompanyDetailsRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface SaveMissingCompanyDetailsRequest {
    missingCompanyDetailsRequest: MissingCompanyDetailsRequest;
}

/**
 * 
 */
export class MissingCompanyDetailsApi extends runtime.BaseAPI {

    /**
     * Save the company details
          */
    async saveMissingCompanyDetailsRaw(requestParameters: SaveMissingCompanyDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['missingCompanyDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'missingCompanyDetailsRequest',
                'Required parameter "missingCompanyDetailsRequest" was null or undefined when calling saveMissingCompanyDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/signup-client/api/missing-company-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MissingCompanyDetailsRequestToJSON(requestParameters['missingCompanyDetailsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Save the company details
          */
    async saveMissingCompanyDetails(requestParameters: SaveMissingCompanyDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.saveMissingCompanyDetailsRaw(requestParameters, initOverrides);
    }

}
